<template>
  <span class="admin-dropdown-container" v-click-outside="clickOutside">
    <button style="display: flex; align-items: center" @click="toogleDropdown">
      {{ capitalizeFirstLetter(text) }}
      <span style="margin: 0 0 5px 8px">
        <i class="admin-arrow admin-down"></i>
      </span>
    </button>
    <div class="admin-dropdown" v-show="show">
      <button
        class="admin-dropdown-item"
        @click="toogleDropdown"
        :disabled="checkDisabled('live')"
      >
        Live
      </button>
      <button
        class="admin-dropdown-item br-top-bottom"
        @click="toogleDropdown"
        :disabled="checkDisabled('draft')"
      >
        Draft
      </button>
      <button
        class="admin-dropdown-item"
        @click="toogleDropdown"
        :disabled="checkDisabled('archive')"
      >
        Archive
      </button>
    </div>
  </span>
</template>


<script>
export default {
  props: {
    text: {
      type: String,
    },
  },

  data() {
    return {
      show: false,
    };
  },
  methods: {
    toogleDropdown() {
      this.show = !this.show;
    },
    checkDisabled(text) {
      switch (this.text) {
        case "draft":
          if (text == "live") return false;
          if (text == "draft") return true;
          if (text == "archive") return false;

        case "archive":
          if (text == "live") return true;
          if (text == "draft") return false;
          if (text == "archive") return true;

        case "live":
          if (text == "live") return true;
          if (text == "draft") return true;
          if (text == "archive") return false;
        default:
          break;
      }
    },
    clickOutside() {
      this.show = false;
    },
  },
};
</script>

<style scoped>
button {
  border: none;
  background-color: transparent;
}

.admin-dropdown-container {
  position: relative;
}

.admin-dropdown {
  position: absolute;
  background-color: white;
  border-radius: 4px;
  border: 1px solid rgba(34, 34, 34, 1);
  z-index: 1;
  width: 100px;
}

.admin-dropdown-item {
  padding: 4px 8px;
  cursor: pointer;
  border: none;
  width: 100%;
  text-align: left;
  padding-left: 10px;
}

.admin-dropdown-item:hover {
  background-color: #f2f2f2;
}

.admin-dropdown-item:disabled:hover {
  background-color: white;
}

.admin-dropdown-item:disabled {
  cursor: default;
  color: rgba(190, 192, 194, 1);
}

.br-top-bottom {
  border-top: 1px solid rgba(34, 34, 34, 1);
  border-bottom: 1px solid rgba(34, 34, 34, 1);
}
</style>
